import { render } from "./Tema.vue?vue&type=template&id=19a85615"
import script from "./Tema.vue?vue&type=script&lang=js"
export * from "./Tema.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__